import React from 'react';
import '../styles/VoicePicker.css';
import '../styles/PronunciationAssessment.css';
import { getVoiceOptions, SPEED_RANGE } from '../config/voiceConfig';
import { Tooltip } from 'react-tooltip';
import { useI18n } from '../i18n';

interface VoicePickerProps {
  rate: number;
  onRateChange: (rate: number) => void;
  selectedAIVoice: string;
  onSelectAIVoice: (voice: string) => void;
}

const VoicePicker: React.FC<VoicePickerProps> = ({
  rate,
  onRateChange,
  selectedAIVoice,
  onSelectAIVoice
}) => {
  const { t } = useI18n();

  // 使用集中配置的語音選項
  const aiVoiceOptions = getVoiceOptions().map(voice => ({
    id: voice.id,
    name: `${voice.name} (${voice.gender === 'male' ? t('voice.genderMale') : t('voice.genderFemale')})`,
    description: t('voice.description', {
      name: voice.name,
      gender: voice.gender === 'male' ? t('voice.genderMale') : t('voice.genderFemale')
    })
  }));
  
  return (
    <div className="voice-picker-container card-section">
      <h3 className="card-header">
        {t('voice.title')}
        <span 
          data-tooltip-id="ai-voice-tooltip"
          data-tooltip-content={t('voice.tooltip')}
          className="voice-picker-tooltip-icon"
        >
          <i className="fas fa-question-circle" />
        </span>
      </h3>
      <Tooltip
        id="ai-voice-tooltip"
        openOnClick
        clickable
        className="voice-picker-tooltip"
      />

      <div className="voice-picker-content">
          
          {/* 語音速率設置 */}
          <div className="rate-control">
            <label htmlFor="speechRate">{t('voice.speed', { rate: rate.toFixed(1) })}</label>
            <input 
              type="range" 
              id="speechRate"
              min={SPEED_RANGE.min} 
              max={SPEED_RANGE.max} 
              step={SPEED_RANGE.step} 
              value={rate} 
              onChange={(e) => onRateChange(parseFloat(e.target.value))}
            />
          </div>
          
          {/* AI語音選擇 */}
            <div className="voice-list ai-voice-list">
              {aiVoiceOptions.map((voice) => (
                <div 
                  key={voice.id} 
                  className={`voice-item ${selectedAIVoice === voice.id ? 'selected' : ''}`}
                  onClick={() => onSelectAIVoice(voice.id)}
                >
                  <div className="voice-name">{voice.name}</div>
                  <div className="voice-lang">{voice.description}</div>
                </div>
              ))}
            </div>
        </div>
    </div>
  );
};

export default VoicePicker; 
